import { services } from '../services';
var action = "priceversion";

export const priceversionService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    last,
    live
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function last(projectId) {
    return services.restApi(`${action}/last/${projectId}`, 'GET');
}

function live(projectId) {
    return services.restApi(`${action}/live/${projectId}`, 'POST', {});
}